import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthorizeGuard } from 'src/app/api-authorization/authorize.guard';
import { AppRouteNames } from './app-paths.constants';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';


const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
  },
  {
    path: AppRouteNames.App.Root,
    loadChildren: () => import('./rek-client-app/rek-client-app.module').then(m => m.RekClientAppModule),
    canActivate: [AuthorizeGuard]
  },
  {
    path: '**',
    component: PageNotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
